<template>
    <div style="overflow:auto">
      <div ref="fadeWhenModelOpen">
          <div>
            <ul class="tags-display-ul p-0 w-100 m-0" style=" display: grid;">
              <div style="display: grid;">
                <li style="display:inline-flex;flex-direction:column">
                  <table
                    style="background: transparent; width: 96%;margin:20px;margin-bottom:10px"
                    >
                    <thead>
                      <tr>
                        <th style="width:15%;margin-inline-end:10px;color:#aaa;padding-inline-end: 20px;padding-bottom: 15px;">
                            Reports
                        </th>
                        <th style="width:10%;margin-inline-end:10px;color:#aaa;padding-inline-end: 20px;padding-bottom: 15px;">
                            Report Interval
                        </th>
                        <th style="width:15%;margin-inline-end:10px;color:#aaa;padding-inline-end: 20px;text-align: start;
                        padding-bottom: 15px;">
                            Email ID
                        </th>
                        <th style="width:5%">
  
                        </th>
                      </tr>
                    </thead>
                    <tbody class="body-half-screen">
                        <template v-for="(item,index) in reportsSchedules">
                            <tr class="comm-table-row" :key="item.unique_id">
                              <td class="text-left" style="margin-inline-end:10px;vertical-align: middle;">
                                <Multiselect
                                :value="item.report_types.length > 0?item.report_types:[]"
                                :options="reportsDropdownValues"
                                :searchable="true"
                                :close-on-select="true"
                                @select="multiPicklistValueTypeOnSelect($event,index)"
                                @remove="multiPicklistValueTypeOnRemove($event,index)"
                                label="name"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                track-by="_id"
                                placeholder="Select reports"
                                :multiple="true">
                                <div slot="tag" slot-scope="option" class="selected-tags-style">
                                  <div class="tags-display-style">{{option.option.name}}</div>
                                      <div class="remove-tag" v-on:click="multiPicklistValueTypeOnRemove(option.option,index)">
                                          <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                          <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                          </svg>
                                      </div>
                                  </div>
                                  <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                  <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,index)" :key="scope.option._id"/>
                                  <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                                </div>
                                </Multiselect>
                              </td>
                              <td class="text-left" style="margin-inline-end:10px;vertical-align: middle;">      
                                <Multiselect
                                :value="item.schedule.length > 0?item.schedule:''"
                                :options="dropdownValues"
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                @select="updateParamter($event,item,'schedule')"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                placeholder="Select report interval">
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">
                                        {{ scope.option }}
                                    </span>
                                </div>
                                </Multiselect>
                              </td>
                              <td class="text-left" style="margin-inline-end:10px;position:relative;" :style="item.report_types.length > 1?'vertical-align: middle':'vertical-align: middle'">
                                <div  v-if="item.email_to.length > 0 && editKey != item.unique_id" class="edit-icon-visibility">
                                 
                                 <span style="width: 100%;word-break: break-word;user-select: text !important; 
                                 cursor:text;">{{
                                    item.email_to.join(', ')
                                  }}</span>
                                  <svg @click="enterIntoEditMode(item)" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pen-fill edit-icon ml-2" style="margin-inline-start:15px;" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/></svg>
                                </div>
                                <div v-else-if="editKey == item.unique_id || item.email_to.length == 0" style="display: flex;
                                align-items: center;width:100%">
                                <div style="position: relative;width:90%">
                                  <textarea
                                    type="text"
                                    id="field_value"
                                    class="rounded text-light comm-input-field-style"
                                    v-model="item.email_to"
                                    @input="validateEmail(item)"
                                    ref="textarea"
                                    autocomplete="off"
                                    @focus="resizeTextarea()"
                                    placeholder="Enter Email ID"
                                    style="min-height: 38px;width:100%;padding:4px 8px;overflow: hidden;border: 1px solid 3a3a3a;
                                    resize: unset;"
                                    ></textarea>
                                  <span v-if="validationMap[item.unique_id] == false" class="pt-1 validationmessage"
                                  >Invalid email address</span
                                >   
                                </div>
                                  <div class="d-flex" style="margin-inline-start: 10px;">
                                    <button @click="updateParamter($event,item,'email_to'),editKey = null" class="btn btn-primary btn-outline-primary button-styles" style="background:transparent;line-height: initial;margin-inline-end:10px;padding:4px">
                                      <svg  width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/></svg>
                                      </button>
                                      <button  @click="editKey = null,getReportsSettingsDataInfo()" class="btn btn-outline-secondary mr-3" style="background:transparent;border-color:#5a5a5a;line-height: initial;padding:4px">
                                        <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>
                                      </button>
                                  </div>
                                </div>                     
                              </td>
                              <td>
                                <svg @click='deleteSelectedParameter(item)' xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash display-icon-on-hover" viewBox="0 0 16 16">
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                </svg>
                              </td>
                            </tr>
                          </template>
                    </tbody>
                  </table>
                  <div class="add-screens-styles" @click="addSelectedQCParameter()">
                    <div style="margin-inline-end:10px">
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg>
                    </div>
                    <div style="font-size: 15px;line-height: 40px;">Add</div>
                  </div>
                </li>
              </div>
            </ul>
        </div>
        </div>
    </div>
  </template>
  
  <script>
  import Multiselect from "vue-multiselect";
import Utils from "../../components.utils.js"
import {mapGetters, mapActions} from "vuex"
  
  export default {
    name: 'ReportsSettings',
    data(){
          return{
              allLabelsDropdown:[],
              enableGeneralTab:true,
              qcParamaters:[],
              reportsDropdownValues:[
                // // {"key":'Audit Trail',"value":"Audit Trail"},
                // // {"key":'Storage',"value":"Storage"},
                // // {"key":'Ingest',"value":"Ingest"},
                // // {"key":'Download',"value":"Download"},
                // // {"key":'Archive',"value":"Archive"},
                // // {"key":'Retrieve',"value":"Retrieve"},
                // // {"key":'Duplicates',"value":"Duplicates"},
                // {"_id":'Assets',"name":"Assets"},
                // {"_id":'Marked_for_delete',"name":"Marked for delete"},
                // {"_id":'Deleted_permanently',"name":"Deleted permanently"},
              ],
              selectedParametersArr:[],
              completeQCConfig:{},
              stagesList:[],
              editKey:null,
              expectedValueMap:{},
              validationMap:{},
              dropdownValues:["Daily", "Weekly", "Monthly"],
              reportsSchedules:[],
              emailRegex: new RegExp(
                /^([a-z0-9._%+-]+)@([a-z0-9.]+)\.([a-z]{2,3})(\.[a-z]{2,3})?$/
              ),
              isEmptyList:false,
              settingsId:'',
              tempReportsSchedulesValue:[]
          }
      },
    methods:{
      ...mapActions('settings',['getReportsSettingsData','updateReportsSettings','addNewPramsInReportSettings','getAllReportsToBeMailed']),
      enterIntoEditMode(emailInfo){
          this.resizeTextarea()
          this.editKey = emailInfo.unique_id;
          this.validationMap[emailInfo.unique_id] = true;
      },
      resizeTextarea() {
        const textarea = this.$refs.textarea;
        if(textarea && textarea[0]){
          textarea[0].style.height = 'auto';
          textarea[0].style.height = `${textarea[0].scrollHeight}px`;
        }
      },
      validateEmail(item){
        this.resizeTextarea();
        const emailPattern = /^([a-z0-9._%+-]+)@([a-z0-9.]+)\.([a-z]{2,3})(\.[a-z]{2,3})?$/;
        let emails = this.convertStringToList(item.email_to);
        this.validationMap[item.unique_id] =  emails.every(email => emailPattern.test(email));
      },
      isPrivilegeExists(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(),priv)
        },
      updateGenericFields(value,key){
        let payload = {};
        payload[key] = value._id;
        this.configureQCgenericConfiguration(payload).then((data) => {
          if (data.status == 200) {
              this.$toast.success("Updated");
          } else {
              this.$toast.error('Failed to update');
          }
        })
      },
      getLabelsArr(){
          this.getLabelsAutocomplete().then((data) => {
              this.allLabelsDropdown = data["labels"];
          });
      },
      getLabelsOnKeyup(keyword){
          let payload ={}
          if(keyword && keyword.length > 0){
              payload['params'] = {'name':keyword}
              this.getLabelsAutocomplete(payload).then((data) => {
                  this.$nextTick(()=>{
                    this.allLabelsDropdown = data["labels"];
                  })
              });
          }else{
              this.getLabelsArr();
          }
      },
      getOperatorsDropdownOfSelectedType(item){
        let index = this.qcParamaters.findIndex(e => e.key == item.key);
        if(index > -1){
          if(this.qcParamaters[index].type && this.qcParamaters[index].type == 'string'){
            return this.stringTypeOperatorsArr;
          }else if(this.qcParamaters[index].type && this.qcParamaters[index].type == 'integer'){
            return this.integerTypeOperatorsArr;
          }
        }else{
          return [];
        }
      },
      setSelectedNavBarAsActive(navbarName){
        this.activeIndex = navbarName;
        if(navbarName == 'general'){
          this.enableGeneralTab = true;
          this.getCompleteQCConfigurations().then((data) => {
            this.completeQCConfig = data;
          })
        }else{
          this.enableGeneralTab = false;
          this.getQCParamtersToShowInDropdown();
          this.getAlreadyConfiguredQCParameters();
        }
      },
      addSelectedQCParameter(){
        let uuid = this.getUUID();
        this.reportsSchedules.push({
            "report_types": [],
            "schedule" : "",
            "email_to" : "",
            "unique_id":uuid,
        })
        this.validationMap[uuid] = true;
        this.editKey = uuid;
        this.tempReportsSchedulesValue = this.tempReportsSchedulesValue.filter(e => e.unique_id != uuid)
      },
      getAlreadyConfiguredQCParameters(){
        let payload = {'type':this.activeIndex}
        this.getConfiguredQCParameters(payload).then((data) => {
          this.selectedParametersArr = data.qc_parameters;
          this.selectedParametersArr.forEach(element => {
              this.expectedValueMap[element.unique_id] = element.expected_value
          });
        })
      },
      multiPicklistValueTypeOnSelect(option,index){
        for (let i = 0; i < this.reportsSchedules.length; i++) {
          if (i !== index) {
            const existingReportTypes = this.reportsSchedules[i].report_types;
            if (existingReportTypes.some(reportType => reportType._id === option._id)) {
              alert('Report already selected');
              this.reportsSchedules[index].report_types = this.reportsSchedules[index].report_types.filter(
                reportType => reportType._id !== option._id
              );
              return;
            }else{
              let checkIndex = this.reportsSchedules[index].report_types.findIndex(e=> e._id == option._id)
              if(checkIndex <= -1){
                this.reportsSchedules[index]['report_types'].push(option);
                if(this.tempReportsSchedulesValue[index] && this.tempReportsSchedulesValue[index].unique_id){
                  this.updateSelectedScheduledReportInfo();
                }
              }
            }
          }else{
            let checkIndex = this.reportsSchedules[index].report_types.findIndex(e=> e._id == option._id)
            if(checkIndex <= -1){
              this.reportsSchedules[index]['report_types'].push(option);
              if(this.tempReportsSchedulesValue[index] && this.tempReportsSchedulesValue[index].unique_id){
                this.updateSelectedScheduledReportInfo();
              }
            }
          }
        }
      },
      multiPicklistValueTypeOnRemove(option,index){
        if(this.reportsSchedules[index]['report_types'].length == 1){
          alert("Report field cannot be empty");
          return;
        }
        this.reportsSchedules[index]['report_types'] = this.reportsSchedules[index]['report_types'].filter(e => e._id != option._id);
        if(this.tempReportsSchedulesValue[index] && this.tempReportsSchedulesValue[index].unique_id){
          this.updateSelectedScheduledReportInfo();
        }
      },
      makePicklistCheckBoxSelection(option, index){
        if(this.reportsSchedules[index] && this.reportsSchedules[index]['report_types']){
          return this.reportsSchedules[index]['report_types'].some((op) => op._id == option._id);
        }
      },
      toggleSelection(option, index) {
        if (this.makePicklistCheckBoxSelection(option, index)) {
          this.multiPicklistValueTypeOnRemove(option, index);
        }else{
          this.multiPicklistValueTypeOnSelect(option, index);
        }
      },
      updateParamter(option,item,key){
        let index = this.reportsSchedules.findIndex(e => e.unique_id == item.unique_id);
        if(index > -1){
          if(key == 'schedule'){
            let update = false;
            if(this.reportsSchedules[index]['schedule'] == 0 || this.editKey == item.unique_id){
              update = false;
            }else{
              update = true;
            }
            this.reportsSchedules[index]['schedule'] = option;
            if(update){
              this.updateSelectedScheduledReportInfo();
            }
          }
          if(key == 'email_to'){
            if(this.validationMap[item.unique_id] == false){
              alert("Enter valid Email ID");
              return;
            }
            this.reportsSchedules[index].email_to = this.convertStringToList(item.email_to)
            if(this.isEmptyList){
              let payload = {};
              payload['configurations'] = this.reportsSchedules;
              this.addNewPramsInReportSettings(payload).then((data) => {
                if (data.statusCode == 200) {
                    this.$toast.success("Updated");
                } else {
                    this.$toast.error('Failed to update');
                }
              })
            }else{
              this.updateSelectedScheduledReportInfo();
            }
          }
        }
      },
      convertStringToList(input) {
        if (!input) return [];

        if (Array.isArray(input)) {
          return input.map(item => String(item).trim());
        }

        if (typeof input === 'string') {
          return input.split(',').map(item => item.trim());
        }
        return [String(input).trim()];
      },
      updateSelectedScheduledReportInfo(){
        let payload = {"configurations":this.reportsSchedules,'_id':this.settingsId};
        this.updateReportsSettings(payload).then((data) => {
          if (data.statusCode == 200) {
              this.$toast.success("Updated");
          } else {
              this.$toast.error('Failed to update');
          }
        })
      },
      deleteSelectedParameter(param){
       if (confirm("Are you sure you want to delete selected row?")) {
          this.reportsSchedules = this.reportsSchedules.filter(e => e.unique_id != param.unique_id);
          this.updateSelectedScheduledReportInfo();
          // setTimeout(() => {
          //   this.getReportsSettingsDataInfo();
          // },200)
        }
      },
      getUUID() {
          var dt = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              var r = (dt + Math.random() * 16) % 16 | 0;
              dt = Math.floor(dt / 16);
              return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
          });
          return uuid;
      },
      getReportsSettingsDataInfo(){
        this.getReportsSettingsData().then((data) => {
          if(data.reports_settings.length == 0){
            this.isEmptyList = true;
          }else{
            this.reportsSchedules = data.reports_settings[0].configurations;
            this.settingsId = data.reports_settings[0]._id;
            this.tempReportsSchedulesValue = data.reports_settings[0].configurations;
          }
        })
      },
      ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
      ...mapGetters("users", ["getLoggedInUserPrivilege",]),
    },
    components:{
      Multiselect
    },
    created(){
        // if(this.isPrivilegeExists("Manage Media Pipeline Reports") && this.getStartUpDataFromInCache().media_pipeline_startup_data && this.getStartUpDataFromInCache().media_pipeline_startup_data.media_pipeline_stage){
        //     let pipLineReports = this.getStartUpDataFromInCache().media_pipeline_startup_data.media_pipeline_stage;
        //     for(let pipeline of pipLineReports){
        //         this.reportsDropdownValues.push({
        //             "key":'media_pipeline_'+pipeline._id,
        //             "value":pipeline.name,
        //         })
        //     }
        //     }

        try {
          this.getAllReportsToBeMailed().then((data) => {
            this.reportsDropdownValues = data.report_types;
            if(!this.reportsDropdownValues){
              this.reportsDropdownValues = [
                {"_id":'Assets',"name":"Assets"},
                {"_id":'Marked_for_delete',"name":"Marked for delete"},
                {"_id":'Deleted_permanently',"name":"Deleted permanently"}
              ];
            }
          })
        } catch (error) {
          this.reportsDropdownValues = [
            {"_id":'Assets',"name":"Assets"},
            {"_id":'Marked_for_delete',"name":"Marked for delete"},
            {"_id":'Deleted_permanently',"name":"Deleted permanently"}
          ];
        }
        this.getReportsSettingsDataInfo();
    },
    mounted() {
      this.resizeTextarea();
    },
  }
  </script>
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $secondary-border-color: 1px solid #2b2b2b;
  $border-on-hover: 1px solid #61707d;
  $add-button-text-color:#0b7099;
  $add-button-text-color-hover:#0193cc;
  $add-button-border-color:#b7b228;
  $add-button-border-on-hover:#dcd426;
  $add-button-backgroud:#1e1e1e;
  $bg-color-on-hover: #22272b;
  $header-background: #1a1a1a;
  $border-color: 1px solid #3a3a3a;
  $background: #121212;
  $body-bg-color: #0d0d0d;
  $background-color-on-hover: #141414;
  $body-background-color: #0d0d0d;
  $dull-text-color: #858585;
  $options-text-color: #9c9c9c;
  $icon-color-on-hover: #9c9c9c;
  $text-color: #eee;
  $table-row-border: none;
  $active-blue: #007bff;
  $danger-color: #dc3545 !important;
  $input-field-bg-color: #121212;
  $input-field-border-color: #202020;
  $input-field-height:38px;
  $button-height:38px;
  $secondary-border-color: 1px solid #3a3a3a;
  $searchBar-border-color: 1px solid #202020;
  $secondary-text-color: #bbb;
  $modal-border:1px solid #202020;
  $modal-background: #0a0a0a;
  $header-color:#9e9e9e;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#141414;
  $scrollbar-thumb-on-hover-background:#555;
  $input-field-padding:3px 5px;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $mutliselect-tag-bg-color:#131313;
  $mutliselect-all-tags-bg-color:#161616;
  $multiselect-option-highlight-bg-color:#333;
  $multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  
  
  .add-screens-styles{
    display: inline-flex;
    height: 40px;
    border: 1px solid $add-button-border-color;
    border-radius: 5px;
    width: 29.5%;
    margin: 20px;
    justify-content: center;
    line-height: 36px;
    color:$add-button-text-color;
    margin-top:0px;
  }
  
  .add-screens-styles:hover{
    border: 1px solid $add-button-border-on-hover;
    color:$add-button-text-color-hover;
  }
    .empty-field-text-styles{
      color:$none-text-color;
    }
    
    .input-field-wrapper{
        display: inline-flex;
        width: 100%;
        position: relative;
        svg{
          position: absolute;
          inset-inline-end: -27px;
          top: 12px;
          height:25px;
        }
    }
    
    .fields-on-non-edit-mode{
      width:70%;
      // display:inline-flex;
      line-height:46px;
      text-align: start;
    }
    
    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position:relative;
    }
        input[type="checkbox"]:after {
            line-height: 1.5em;
            content: "";
            display: inline-block !important;
            width: 22px !important;
            height: 21px !important;
            margin-top: 5px !important;
            margin-inline-start: -1px !important;
            border: $border-color !important;
            border-radius: 0.25em !important;
            background: $primary-background !important;
        }
        input[type="checkbox"]:checked:after {
            content: "✔";
            color: $active-blue !important;
            position: absolute !important;
            font-size: 16px !important;
            line-height: 1 !important;
            transition: all 0.2s !important;
            font-family: Helvetica, Arial, sans-serif;
            padding-inline-start: 4px !important;
            padding-top: 2px !important;
        }
    
    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }
    
    .tags-display-ul{
      list-style-type: none;
    }
    
    .tags-display-ul .show-tags-delete{
      visibility:hidden;
    }
    
    .searched-metadata-display-fields{
      height: auto;
      width: 90%;
    }
    
    .view-tags:hover {
      .show-tags-delete{
        visibility: visible;
      }
      .comm-table-row{
        background: #a3a3a3;
      }
    }

    .view-tags:hover {
      border: $border-on-hover !important;
    }

    td{
      padding: 5px 0px;
    }
    
    .key-style {
      color: $dull-text-color;
      width: 30%;
      text-align: center;
      font-size: $input-field-and-label-font-size;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 13px;
    }
    
    .activeTag{
        color: $active-blue !important;
    }
    .view-tags{
          font-size: 12px;
          height: 24px;
          display: inline-flex;
          margin:2px !important;
          border: $border-color !important;
          border-radius: 15px !important;
          min-width: 50px;
          padding: 0px !important;
          text-align: center;
          width:auto !important;
          padding-inline-start: 12px !important;
          justify-content: center;
          padding-top: 1px !important;
          div{
                  padding: 0px 8px;
                  margin-inline-start: 0px;
                  font-size: 12px;
                  border-radius: 15px !important;
                  position: relative;
                  top: 1px;
          }
        }
    
      .view-fields-styles{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: start;
        width:98% !important;
        padding-inline-start: 12px !important;
        justify-content: start;
        padding-top: 1px !important;
        div{
                padding: 0px 8px;
                margin-inline-start: 0px;
                font-size: 14px;
                line-height: 32px;
                color: $secondary-text-color;
                text-align:end;
        }
      }
    
      .comm-input-field-style{
        background: $primary-background!important;
        width: 100%;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: 42px;
    }
    
    .comm-tags-field-wrapper-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        min-height: $input-field-height;
        margin-top:1px;
        margin-bottom:1px;
        border-radius: 4px;
    }
    
  
  .comm-input-field-style{
      background: $primary-background;
      float: inline-start;
      padding: $input-field-padding;
      border: $border-color;
      font-size:$input-field-and-label-font-size;
      height: $input-field-height;
      width: 60%;
  }
  
  
  .connect-wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
    .comm-connect-class{
      border: $border-color;
      border-radius: 4px;
      margin: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      position:relative;
      padding:49px;
      img{
        height:50%;
      }
    }
  }
  
  .config-label{
      width: 9%;
      display: flex;
      align-items: center;
      justify-content: end;
      color: $secondary-text-color;
      margin-inline-end:7px;
  }
  
  
  
    .nav-item{
      color:$dull-text-color;
      font-size: 16px;
    }
  
    .nav-item:hover{
      color:$active-blue !important;
      border-bottom: 2px solid $active-blue;
    }
    .active{
      color:$active-blue !important;
      border-bottom: 2px solid $active-blue;
    }
  
  
  .primary-btn-style{
      margin-top: 3px;
      margin-inline-start: 11px;
      height: 37px;
  }
  
  .config-field-wrapper{
      width: 80%;
      display: flex;
      flex-direction: row;
      margin-inline-start: 8px;
  }
  
  .comm-input-field-style{
      background: $primary-background!important;
      float: inline-start;
      padding: $input-field-padding;
      border: $border-color!important;
      font-size:$input-field-and-label-font-size;
      height: $input-field-height;
  }
  
  .custom-control-label {
      position: relative;
      margin-bottom: 0;
      vertical-align: top;
  }
    .custom-control {
        position: relative;
        z-index: 1;
        display: block;
        min-height: 1.5rem;
        padding-inline-start: 1.5rem;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
    }
  
    .custom-control-input {
        position: absolute;
        // inset-inline-start:18px;
        z-index: 9;
        width: 1rem;
        height: 1.25rem;
        opacity: 0;
    }
  
   .custom-control-label:before {
        background-color: #0d0d0d;
    }
  
    .custom-switch .custom-control-label:before {
        width: 1.75rem;
        pointer-events: all;
        border-radius: 0.5rem;
    }
  
    .custom-control-input:checked ~ .custom-control-label:before {
        border-color: #007bff;
        background-color: #007bff;
    }
  
    .custom-control-label:before,
    .custom-file-label,
    .custom-select {
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }
  
    .custom-switch .custom-control-input:checked ~ .custom-control-label:after {
        transform: translateX(0.75rem);
    }
  
    .custom-switch .custom-control-label:after {
          top: calc(0.25rem + 2px);
          inset-inline-start:2px;
        //   width: calc(1rem - 4px);
        //   height: calc(1rem - 4px);
            // top: calc(0.25rem + 2px);
            // inset-inline-start :calc(-2.25rem + 2px);
            width: calc(1rem - 4px);
            height: calc(1rem - 4px);
  
        background-color: #adb5bd;
        border-radius: 0.5rem;
        transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
  
    .custom-control-label:after {
        background: 50%/50% 50% no-repeat;
    }
  
    .custom-control-label:after,
    .custom-control-label:before {
        position: absolute;
        top: 0.25rem;
        display: block;
        width: 1rem;
        height: 1rem;
        content: "";
    }
  
    .custom-control-label:before {
        pointer-events: none;
        border: 1px solid #adb5bd;
    }
    .config-desc {
        width: 100%;
        text-align: initial;
        color: $dull-text-color;
    }
  
  .input-field-label{
      float: inline-start;
      width: 350px;
      padding: 6px 10px;
      text-align: end;
      // height:30px;
      color:#9b9a9a;
      word-break: break-word;
  }  
  
  .editIconClass{
    visibility: hidden;
    margin-inline-start: 8px;
  }
  
  .editIcon{
    display: inline-flex; 
    width: auto; 
    float: inline-start;
    align-items: center;
    color: #bababa;
  }
  
  .comm-hype-fields:hover{
      .editIconClass{
          visibility: visible !important;
      }
  }
  .comm-hype-fields{
    .editing-filed-div{
      width:calc(100% - 370px);
      display: inline-flex;
      align-items: center;
    }
  }  
  
  .hype-data-value{
    display: inline-flex;
    align-items: center;
    color:#fff;
    margin-inline-end:10px;
  }
  
  /* width */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }
  
  ::v-deep {
          textarea::placeholder {
            color: grey; /* Change this to your desired color */
            opacity: 1; /* Change this if you need to adjust the opacity */
        }
          .multiselect{
              width:93%;
              margin: 3px 0px;
          }
          .multiselect__tags-wrap{
              display:block;
          }
          .multiselect__content-wrapper{
              display:none;
          }
          .multiselect__tag, .tags-style {
              background-color: $primary-background !important;
              border: $border-color;
              border-radius: 5px;
              margin-bottom:0px;
          }
          .multiselect__tags, .tags-style {
              background: $primary-background !important;
              border: $border-color !important;
          }
          .multiselect__option--highlight {
              background: $bg-color-on-hover !important;
          }
          .multiselect__content {
              background: $secondary-background-color !important;
          }
          .multiselect__input, .multiselect__single {
              background: transparent !important;
              color:$text-color;
          }
          .multiselect__input:focus{
              outline:none;
              box-shadow: none;
          }
          .multiselect__tag-icon{
          color:$text-color;
          }
          .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
              background: $bg-color-on-hover !important;
              color: $text-color !important;
          }
          .multiselect__tag-icon:after{
          color:$secondary-text-color !important;
          font-size: 20px;
          }
          .multiselect *{
              font-size: $input-field-and-label-font-size;
              font-family: "Roboto", Arial, sans-serif !important;
          }
          .multiselect__tags{
            padding: 2px 35px 2px 6px !important;
            display: flex !important;
            align-items: flex-start;
            flex-direction: column;
            justify-content: center;      
          }
  
          .multiselect__select{
              width:35px !important;
          }
          
          .multiselect__placeholder {
              // padding-top: 5px !important;
              margin-bottom:0px;
              color:#b7b7b7 !important;
          }
          .multiselect{
              color:$text-color !important;
              font-size: $input-field-and-label-font-size !important;
              min-height: 36px;
          }
          .multiselect__single{
                  margin: 0!important;
                  height: 100%;
                  display: flex;
                  align-items: center;
          }
          .multiselect__option--selected{
              background:$bg-color-on-hover !important;
              color: $text-color;
          }
          .multiselect__content-wrapper{
              border: 1px solid $bg-color-on-hover !important;
              position: absolute;
              display: block;
              background: $text-color;
              width: 100% !important;
              max-height: 120px;
              overflow: auto;
              border: 1px solid $text-color;
              border-top: none;
              border-bottom-left-radius: 5px;
              border-bottom-right-radius: 5px;
              z-index: 50;
              -webkit-overflow-scrolling: touch;
              // width:auto !important;
          }
          .projectDropdownFilter{
              .multiselect__content-wrapper{
                  width:auto !important;
              }
          }    
          .multiselect__select,.multiselect__current,.multiselect__option{
              line-height: 12px !important;
          }
          .multiselect--above .multiselect__content-wrapper{
          background: $secondary-background-color !important;
          }
          .multiselect__tags {
              background: $primary-background !important;
              height: auto;
          }
          
          input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
              outline: none;
              --saf-0: rgba(var(--sk_highlight,18,100,163),1);
              box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
              border-radius: 4px;
              border-color: transparent;
              -webkit-appearance: none;
          }
  
          .multiselect__tags {
            input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
              outline: none;
              --saf-0: rgba(var(--sk_highlight,18,100,163),1);
              box-shadow: none !important;
              border-radius: 4px;
              border-color: transparent;
              -webkit-appearance: none;
              color: #eee !important;
            }  
            input::placeholder{
              color:#7a7a7a !important;
            }
          }
      }
  
      /* width */
      ::-webkit-scrollbar {
        width: 8px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
      }

      .add-new-lists-styles{
        display: inline-flex;
        border-radius: 10px;
        margin: 0px 8px;
        justify-content: start;
        height: 27px;
        color:$add-button-text-color;
        padding: 4px 0px 0px 0px;
          svg{
              top:0px;
              fill:$add-button-text-color !important;
          }
      }
  
      .add-new-lists-styles:hover{
          color:$add-button-text-color-hover;
          svg{
              fill:$add-button-text-color-hover !important;
          }
      }
  
      .selected-tags-style{
          font-size:12px!important;
          height: 30px!important;
          display: inline-flex!important;
          margin: 2px!important;
          border: 1px solid $tags-border-color!important;
          border-radius: 15px!important;
          min-width: 50px!important;
          padding: 0!important;
          text-align: center;
          width: auto!important;
          padding-inline-start: 10px!important;
          justify-content: center;
          padding-top: 1px!important;
          background: $tags-background-color;
          align-items: center;
          .remove-tag{
              line-height:18px;
              color: #858585;
              svg{
                  top: -2px;
                  inset-inline-end: 2px;
              }
          }
      }
  
     .validationmessage{
         display: inline-block;
     }
  
     .privacy-policy-styles{
      color: $dull-text-color;
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      bottom: -3px;
      background: $primary-background;
      span:hover{
        text-decoration: underline;
      }
      span{
        margin-inline-end: 15px;
      }
     }
  
     .display-icon-on-hover{
      fill:#aaa;
      visibility:hidden;
     }  
  
     .comm-table-row:hover{
      background:#1f2528fa;
      .display-icon-on-hover{
        visibility:visible;
      }
     }
  
     .plugin-config-ul {
      list-style-type: none;
      display: inline-flex;
      width: 100%;
      overflow:auto;
      padding-top: 10px;
      // height: calc(100vh - 350px);
      overflow: auto;
      height: 85vh;
      padding-inline-start:0px;
  }
  
  .plugin-config-ul li {
      width: 100%;
      display: inline-flex;
      margin-bottom: 20px;
  }
  
  .plugin-config-ul li .config-label {
      width: 20%;
      text-align: end;
      color: #757575;
      word-break: break-word;
      position: relative;
      top: 9px;
  }
  
  .plugin-config-ul li .config-value {
      margin-inline-start: 14px;
      // width: 24%;
      display:grid;
      svg{
          position: relative;
          top: 9px;
          margin-inline-start: 10px;
      }
  }
  
  .plugin-config-ul li .config-value input,select {
      width: 100%;
      // height: 27px;
      color: #eee !important;
      padding-inline-start: 2px;
      background: transparent;
      border: 1px solid #3a3a3a !important;
      border-radius: 4px;
  }
  
  .plugin-config-ul li .config-value .config-details {
      font-size: 14px;
      // color: #757575;
      text-align: start;
      padding-inline-start: 11px !important;
      color:$dull-text-color;
  }
  
  .active {
      color: #49d749;
      float: inline-start;
      padding-inline-start:10px;
  }
  
  
  .check-again {
      font-size: 13px;
  }
  
  .primary-btn-style {
      margin-top: 1%;
  }
  
  .primary-btn-style button {
      height: 25px;
      padding: 0px;
      width: 70px;
      font-size: 14px;
  }
   /* width */
  ::-webkit-scrollbar {
      width: 8px;
      height:8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
      background: #141414;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #333;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #555;
  }
  
  .edit-icon{
      visibility: hidden;
  }
  
  .edit-icon-visibility{
      width: 85%;
  }
  
  .edit-icon-visibility:hover{
      .edit-icon{
          visibility: visible;
      } 
  }
  
  .commDefaultInputFields{
      border: none !important;
      background: transparent !important;
      cursor: pointer;
      pointer-events: auto;
      outline: none;
  }
  
  .comm-input-field-style{
      background: $input-field-bg-color;
      // width: 100% !important;
      float: inline-start;
      padding: $input-field-padding;
      border: 1px solid $input-field-border-color;
      font-size:$input-field-and-label-font-size;
      height: $input-field-height;
  }
  
  .key-div {
      text-align: end;
      color: $dull-text-color;
      position: relative;
      top: 9px;
      margin-inline-end: 20px;
      width:10%;
  }
  .value-div {
      text-align: start;
      margin-inline-start: 10px;
      display:block;
      width:50%;
      .validationmessage{
          padding-inline-start:7px !important;
          // position: relative;
          // top: 9px;
          color:$dull-text-color;
      }
      svg{
          position: relative;
          top: 9px;
          margin-inline-start:10px;
      }
  }

  .validationmessage {
    color: $danger-color;
    font-size: 11px;
    position: absolute;
    inset-inline-start:1px;
    bottom: -17px;
  }
  
  .commDefaultInputFields{
    border: none !important;
    background: transparent !important;
    cursor: pointer;
    pointer-events: auto;
    outline: none;
  }

  </style>
  